<svg [climbIcon]="icons.doc"></svg>
<span #buttonLabel class="button-label"><ng-content></ng-content></span>
